import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./threat-group-query-key-factory";

export const getThreatGroups = () => {
  return Brm.threatGroupApi.findThreatGroup();
};

interface IUseThreatGroups {
  options?: QueryOption<typeof getThreatGroups>;
}

/**
 * React-query hook for getting all Threat Groups
 *
 * @param
 * @returns react-query for getThreatGroups
 */
export const useThreatGroups = ({ options }: IUseThreatGroups = {}) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.threatGroupKeys.all,
    queryFn: () => getThreatGroups(),
  });
};
